import {video} from "./client";

/**
 * Comprueba que se hayan seleccionado los inputs necesarios para proceder
 * a crear o unirse a una habitación.
 * @param {boolean} master - si se va a crear una habitación (true) o unirse (false)
 * @param {string} id
 * @param {string} [url='']
 */
export function checkInputs(master, id, url = '') {
  if (master) {
    if (id === '' || url === '') {
      alert("ID or URL have no value");
      return false;
    }
  } else {
    if (id === '') {
      alert("ID has no value");
      return false;
    }
  }
  return true;
}